﻿import {LocationIsoModalViewModel} from './locationIsoModal.viewmodel';
import * as Repositories from '../../../repositories/repositories';
import * as Model from '../../../models/models';
import * as lodash from 'lodash';

export class LocationIsoModalGateway {

    public vm: LocationIsoModalViewModel;

    public static $inject = ['$q', '$log', 'addressRepository', 'locationRepository'];

    constructor(private $q: ng.IQService,
        private $log: ng.ILogService,
        private addressRepository: Repositories.AddressRepository,
        private locationRepository: Repositories.LocationRepository) { }

    public loadGraphModel(
        viewModel: LocationIsoModalViewModel, 
        submission: Model.ISubmission, 
        locationAggregate?: Model.ILocationAggregate
    ): ng.IPromise<any> {

        this.vm = viewModel;
        this.vm.submission = submission;
        this.vm.locationCreateRequest = new Model.LocationCreateRequest();
        
        if (locationAggregate) {
            this.vm.isEdit = true;
            this.vm.locationAggregate = locationAggregate;
            this.mapLocationToRequest();
        }

        return this.$q.when(this.vm);
    }

    public addLocation = (isoLocationLookup: Model.ILocationCreateRequest): ng.IPromise<any> => {
        this.mapSubmissionToLocationRequest(isoLocationLookup);
        return this.locationRepository.createLocation(isoLocationLookup);
    }

    public editLocation = (locationRequest: Model.ILocationCreateRequest, locationAggregate: Model.ILocationAggregate): ng.IPromise<any> => {
        
        this.mapSubmissionToLocationRequest(locationRequest);
        
        const locationUpdateRequest = locationRequest as Model.ILocationUpdateRequest;
        locationUpdateRequest.addressId = locationAggregate.addressId;
        locationUpdateRequest.locationId = locationAggregate.id;

        return this.locationRepository.updateLocation(locationUpdateRequest);
    }

    private mapSubmissionToLocationRequest(locationRequest: Model.ILocationCreateRequest): void {
        locationRequest.effectiveDate = this.vm.submission.policyEffectiveDate;
        locationRequest.submissionId = this.vm.submission.id;
        locationRequest.occupantComparisons = [this.vm.submission.doingBusinessAs, this.vm.submission.legalBusinessName];
        locationRequest.policyholderId = this.vm.submission.policyholderId;
    }

    private mapLocationToRequest(): void {
        this.vm.locationCreateRequest.streetAddressLine1 = this.vm.locationAggregate.address.streetAddressLine1;
        this.vm.locationCreateRequest.streetAddressLine2 = this.vm.locationAggregate.address.streetAddressLine2;
        this.vm.locationCreateRequest.city = this.vm.locationAggregate.address.city;
        this.vm.locationCreateRequest.state = this.vm.locationAggregate.address.state;
        //this.vm.locationCreateRequest.county = this.vm.locationAggregate.address.county;
        this.vm.locationCreateRequest.zipCode = this.vm.locationAggregate.address.zipCode;
        this.vm.locationCreateRequest.name = this.vm.locationAggregate.name;

    }
}